import { IColor } from '../../components/ConnectionsPanels/types';

export enum DeviceStateValues {
  ON = 'ON',
  OFF = 'OFF'
}

export type ActionSwitchType = {
  SwitchAction: DeviceStateValues;
};

export type ActionPlaySoundType = {
  SoundNumber: number;
};

export type ActionSwitchFrameLedType = IColor & {
  SwitchFrameLedAction: DeviceStateValues;
};

export type ActionInvokeSceneType = {
  SceneId: string;
};

export type DeviceActionParamType = ActionSwitchType &
  ActionPlaySoundType &
  ActionSwitchFrameLedType &
  ActionInvokeSceneType;

export type DeviceActionType = {
  actionParameters: DeviceActionParamType;
  device: any;
  dockNumber: string;
  deviceNumber: string;
};

export default DeviceStateValues;
